export default __webpack_public_path__ + "static/Kia Ceed-939e4779b479a81079ac29e4f5adcf15.png";